export const appSettings = {
  version: '0.0.1',
  appName: 'Leadsform',
  appTitle: 'Leadsform',
  clientInfoUrl: "https://us-central1-hdsolapps.cloudfunctions.net/getClientInfo",
  firebaseConfig: {
    apiKey: "AIzaSyCWnyqM3kTebPQmTHqVPGPZGMlVXqHvc2Y",
    authDomain: "hdsolapps.web.app",
    databaseURL: "https://hdsolapps.firebaseio.com",
    projectId: "hdsolapps",
    storageBucket: "hdsolapps.appspot.com",
    messagingSenderId: "283206993339",
    appId: "1:283206993339:web:8374a47e26c6a7090a309e",
    measurementId: "G-PG5QGET07C"
  },
  thankYouUrl: "https://www.kjellsmarkiser.no/takk"
}